export default [
  "nodes/trim-car-t.png",
  "nodes/trim-warez-o.png",
  "nodes/trim-ph-o.png",
  "nodes/trim-donut-o.png",
  "nodes/trim-hq-o.png",
  "nodes/trim-ped-t.png",
  "nodes/trim-lmm-o.png",
  "nodes/under-selected.png",
  "nodes/trim-lmm-t.png",
  "nodes/trim-ped-o.png",
  "nodes/trim-smart.png",
  "nodes/trim-hq-t.png",
  "nodes/trim-ph-t.png",
  "nodes/trim-donut-t.png",
  "nodes/trim-warez-t.png",
  "nodes/trim-car-o.png",
  "tutorial-arrow.png",
  "arrow.png",
  "programs/WolfSpider.png",
  "programs/GolemClay.png",
  "programs/MemoryHog.png",
  "programs/Tarantula.png",
  "programs/Ballista.png",
  "programs/Satellite.png",
  "programs/GolemStone.png",
  "programs/LogicBomb.png",
  "programs/BitMan.png",
  "programs/Buzzbomb.png",
  "programs/Watchman.png",
  "programs/Clog.png",
  "programs/Radar.png",
  "programs/Boss.png",
  "programs/TurboDX.png",
  "programs/FireWall.png",
  "programs/Wizard.png",
  "programs/Sumo.png",
  "programs/WatchmanSP.png",
  "programs/BlackWidow.png",
  "programs/DataDoctor.png",
  "programs/WardenPP.png",
  "programs/WatchmanX.png",
  "programs/LaserSatellite.png",
  "programs/Sensor.png",
  "programs/Turbo.png",
  "programs/Warden.png",
  "programs/Tower.png",
  "programs/Mandelbug.png",
  "programs/AttackDog.png",
  "programs/Sonar.png",
  "programs/Seeker.png",
  "programs/GuardPup.png",
  "programs/WardenP.png",
  "programs/Seeker3.png",
  "programs/DataDoctorPro.png",
  "programs/Hack.png",
  "programs/Catapult.png",
  "programs/Seeker2.png",
  "programs/Hack2.png",
  "programs/Clog2.png",
  "programs/Medic.png",
  "programs/MobileTower.png",
  "programs/Sentinel.png",
  "programs/Bug.png",
  "programs/Clog3.png",
  "programs/Hack3.png",
  "programs/Heisenbug.png",
  "programs/GolemMud.png",
  "programs/Sentinel3.png",
  "programs/Slingshot.png",
  "programs/GuardDog.png",
  "programs/Sentinel2.png",
  "programs/Fiddle.png",
  "programs/Guru.png",
  "scroll-arrow-down.png",
  "scroll-arrow-up.png",
  "bg/code.jpg",
  "bg/ph-logo.png",
  "bg/warez-logo.png",
  "bg/donut-logo-text.png",
  "bg/lmm-logo.png",
  "bg/parker-ellington-davis.jpg",
  "bg/ped-logo.png",
  "bg/netmap.png",
  "bg/cellular-automata.jpg",
  "bg/car-logo.png",
  "bg/smart-logo.png",
  "bg/lmm-logo-text.png",
  "bg/dr-donut.jpg",
  "bg/lucky-monkey.jpg",
  "bg/pharmhaus.jpg",
  "bg/donut-logo.png",
  "characters/joana.png",
  "characters/leo.png",
  "characters/wintermutant.png",
  "characters/superphreak.png",
  "characters/disarray.png",
  "characters/spinner.png",
  "characters/kimoni.png",
  "characters/tsumara.png",
  "characters/minerva.png",
  "grid/neutral-target.png",
  "grid/upload-zone.png",
  "grid/redcheck.png",
  "grid/movement-arrow.png",
  "grid/data.png",
  "grid/credit.png",
  "grid/possible-dest.png",
  "grid/attack-target.png",
  "grid/helper-target.png",
];
